export default __webpack_public_path__ + "static/media/floor-4.50fefe10.jpg";